import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-html-content',
  templateUrl: './html-content.component.html',
  styleUrls: ['./html-content.component.scss']
})
export class HtmlContentComponent implements OnChanges {
  @Input() form!: FormGroup;
  @Input() controlName!: string;

  sanitizedContent!: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {
  }
  ngOnChanges(): void {
    this.sanitizeContent(this.form?.get(this.controlName)?.value);

    this.form?.get(this.controlName)?.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
      this.sanitizeContent(value);
    });
  }
  
  sanitizeContent(value?: string) {
    if (!value) {
      this.sanitizedContent = '';
      return;
    }
    this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(value);
  }

}
